
// Material Icons
import {
    // Navigation & Actions
    Close,
    Menu,
    ArrowBack,
    ArrowForward,
    ArrowDropDown,
    Add,
    Remove,
    Edit,
    Delete,
    Save,
    Cancel,
    Check,
    CheckCircle,
    TrendingUp,
    TrendingDown,

    // Content & Media
    Upload,
    Download,
    Image,
    PhotoCamera,
    Crop,

    // Communication & Social
    Email,
    Phone,
    Chat,
    WhatsApp,
    Facebook,
    Google,
    Star,
    StarBorder,

    // Business & Commerce
    Store,
    ShoppingCart,
    Restaurant,
    Hotel,
    Flight,
    Home,
    Work,
    Business,
    LocationOn,
    People,

    // Status & Alerts
    Info,
    Warning,
    Error,
    CheckCircle as Success,
    Notifications,

    // UI Elements
    Visibility,
    VisibilityOff,
    Settings,
    Palette,
    Link,
    GridView,
    ViewList,
    ViewCarousel,
    Badge,

    // Dashboard & Analytics
    Dashboard,
    BarChart,
    Widgets,
    Assessment,

    // User & Profile
    Person,
    AccountCircle,

    // Tech & Development
    Code,
    Web,
    Build,
    Article,
    Computer,
    Smartphone,
    Tablet,
    ChatBubbleOutline,
    RadioButtonUnchecked,
    Power,
    DisplaySettings,
    HelpOutline,
    Schedule,
    AccessTime,

} from '@mui/icons-material';

// Icon mapping for easy access
export const MaterialIcons = {
    // Navigation & Actions
    close: Close,
    menu: Menu,
    back: ArrowBack,
    forward: ArrowForward,
    dropdown: ArrowDropDown,
    add: Add,
    remove: Remove,
    edit: Edit,
    delete: Delete,
    save: Save,
    cancel: Cancel,
    check: Check,
    checkCircle: CheckCircle,
    trendingUp: TrendingUp,
    trendingDown: TrendingDown,

    // Content & Media
    upload: Upload,
    download: Download,
    image: Image,
    camera: PhotoCamera,
    crop: Crop,

    // Communication & Social
    email: Email,
    phone: Phone,
    chat: Chat,
    whatsapp: WhatsApp,
    facebook: Facebook,
    google: Google,
    star: Star,
    starOutline: StarBorder,
    instagram: Person, // Using person icon as fallback for Instagram profile

    // Business & Commerce
    store: Store,
    shopping: ShoppingCart,
    restaurant: Restaurant,
    hotel: Hotel,
    flight: Flight,
    home: Home,
    work: Work,
    business: Business,
    location: LocationOn,
    people: People,

    // Status & Alerts
    info: Info,
    warning: Warning,
    error: Error,
    success: Success,
    notifications: Notifications,

    // UI Elements
    visibility: Visibility,
    visibilityOff: VisibilityOff,
    settings: Settings,
    palette: Palette,
    link: Link,
    grid: GridView,
    list: ViewList,
    carousel: ViewCarousel,
    badge: Badge,

    // Dashboard & Analytics
    dashboard: Dashboard,
    analytics: BarChart,
    widgets: Widgets,
    assessment: Assessment,

    // User & Profile
    person: Person,
    profile: AccountCircle,

    // Tech & Development
    code: Code,
    web: Web,
    build: Build,
    article: Article,
    computer: Computer,
    mobile: Smartphone,
    tablet: Tablet,
    desktop: Computer,
    editNote: Edit,
    comment: ChatBubbleOutline,
    circle: RadioButtonUnchecked,
    power: Power,
    display: DisplaySettings,
    help: HelpOutline,
    schedule: Schedule,
    time: AccessTime,
};

// Widget type icons mapping
export const WidgetTypeIcons = {
    'reviews-carousel': MaterialIcons.carousel,
    'reviews-grid': MaterialIcons.grid,
    'reviews-list': MaterialIcons.list,
    'reviews-testimonial': MaterialIcons.chat,
    'reviews-badge': MaterialIcons.badge,
    'reviews-floating': MaterialIcons.notifications,
    'whatsapp': MaterialIcons.whatsapp,
    'appointment': MaterialIcons.schedule,
};

// Platform fallback icons mapping (replacing emoji)
export const PlatformFallbackIcons = {
    'google': MaterialIcons.google,
    'facebook': MaterialIcons.facebook,
    'yelp': MaterialIcons.restaurant,
    'tripadvisor': MaterialIcons.flight,
    'airbnb': MaterialIcons.home,
    'booking': MaterialIcons.hotel,
    'amazon': MaterialIcons.shopping,
    'apple-app-store': MaterialIcons.store,
    'bbb': MaterialIcons.business,
    'capterra': MaterialIcons.work,
    'dealerrater': MaterialIcons.store,
    'ebay': MaterialIcons.shopping,
    'edmunds': MaterialIcons.store,
    'g2': MaterialIcons.star,
    'google-play': MaterialIcons.store,
    'hotels': MaterialIcons.hotel,
    'houzz': MaterialIcons.home,
    'linkedin': MaterialIcons.work,
    'opentable': MaterialIcons.restaurant,
    'trustpilot': MaterialIcons.star,
    'sitejabber': MaterialIcons.chat,
    'foursquare': MaterialIcons.store,
    'glassdoor': MaterialIcons.business,
    'indeed': MaterialIcons.work,
    'zillow': MaterialIcons.home,
    'healthgrades': MaterialIcons.business,
    'vitals': MaterialIcons.business,
    'zocdoc': MaterialIcons.business,
    'grubhub': MaterialIcons.restaurant,
    'doordash': MaterialIcons.restaurant,
    'all': MaterialIcons.star
};

// Material Icon component wrapper for consistent styling
export const Icon = ({
    name,
    className = "",
    size = 24,
    color = "inherit",
    onClick,
    style = {}
}) => {
    const IconComponent = MaterialIcons[name];

    if (!IconComponent) {
        console.warn(`Icon "${name}" not found in MaterialIcons`);
        return null;
    }

    return (
        <IconComponent
            className={className}
            onClick={onClick}
            style={{
                fontSize: size,
                color: color,
                ...style
            }}
        />
    );
};

// Specialized icon components for common use cases
export const StatusIcon = ({ type, className = "", size = 24 }) => {
    const iconMap = {
        success: { icon: MaterialIcons.checkCircle, color: '#10B981' }, // green-500
        error: { icon: MaterialIcons.error, color: '#EF4444' },         // red-500
        warning: { icon: MaterialIcons.warning, color: '#F59E0B' },     // yellow-500
        info: { icon: MaterialIcons.info, color: '#3B82F6' }           // blue-500
    };

    const { icon: IconComponent, color } = iconMap[type] || iconMap.info;

    return (
        <IconComponent
            className={className}
            style={{ fontSize: size, color }}
        />
    );
};

export default MaterialIcons;
